import React from 'react'
import { useTheme } from 'styled-components'

import { ListingDetailsDivider } from '@/components/shared/core-listing-card/card-details/ListingDetailsDivider'
import { AutosAttributeListItem } from '@/components/srp/listing-card/autos-attribute-list/AutosAttributeListItem'
import { AutosAttributeListFlex } from '@/components/srp/listing-card/autos-attribute-list/styled'

type AutosAttributeListProps = {
  attributes: string[]
}

// TODO: We can migrate this to use the List component from @kijiji/ui once it's able to support all the small tweaks we need.
export const AutosAttributeList = ({ attributes }: AutosAttributeListProps) => {
  const { spacing } = useTheme()

  return (
    <AutosAttributeListFlex
      flexDirection="row"
      flexWrap="wrap"
      columnGap={spacing.defaultSmall}
      alignItems="center"
    >
      {attributes.map((attribute, index) => {
        return (
          <React.Fragment key={attribute}>
            <AutosAttributeListItem text={attribute} />
            {index < attributes.length - 1 && (
              <ListingDetailsDivider data-testid="listing-details-divider" variant="dot" visible />
            )}
          </React.Fragment>
        )
      })}
    </AutosAttributeListFlex>
  )
}
